import { Home } from '@/model/conteudo/home';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  @Input()
  home:Home = new Home();

  constructor(){
  }

  ngOnInit(): void {
  }

}

